import {
  getAuthorization,
  deregisterAccount,
  changePassword,
  updateMemberInfo,
  loginViaFB,
  signup,
  resetPassword,
} from 'services/CommonServices';

class LoginService {
  deregisterAccount(data) {
    return deregisterAccount(data);
  }

  changePassword(data) {
    return changePassword(data.userId, data.oldPassword, data.newPassword);
  }

  updateUserInfo(data) {
    return updateMemberInfo(data.memberId, data.data);
  }

  login(email, password) {
    return getAuthorization(email, password);
  }

  loginViaFB(fbId, email, firstName, lastName) {
    return loginViaFB(fbId, email, firstName, lastName);
  }

  signup(data) {
    return signup(data);
  }

  resetPassword(email) {
    return resetPassword(email);
  }
}

export default new LoginService();
